import { Modal } from 'antd';

/**
 * The one destructive confirm (delete audit F15). Every dialog that removes,
 * revokes, resets or discards something goes through here, so three things
 * can never drift apart again:
 *
 *   - the OK button is red (`danger`),
 *   - CANCEL has the focus — Enter never destroys anything. antd focuses OK
 *     by default, and until 2026-09 every one of the platform's 35
 *     `Modal.confirm`s did: a stray Enter after a click deleted the item;
 *   - the default verb is "Delete", overridable per call ("Remove", "Revoke",
 *     "Reset").
 *
 * `modalApi` is antd's `App.useApp().modal` (themed) where the caller has
 * one; the static `Modal` stands in otherwise (the same fallback as
 * askDiscardChanges in contexts/UnsavedChangesContext.js). Every other
 * `Modal.confirm` option passes through; `okButtonProps` is merged, never
 * replaced, so a caller can add `loading` without losing the red.
 *
 * Returns antd's instance ({ destroy, update }), as `modal.confirm` does.
 *
 * Not for a typed-word confirm: a collection's, a card's or an account's
 * delete arms on a typed word through `ConfirmWordModal`.
 */
export function confirmDestructive(modalApi, options = {}) {
	const api = modalApi && typeof modalApi.confirm === 'function' ? modalApi : Modal;
	const { okButtonProps, okText, cancelText, ...rest } = options;
	return api.confirm({
		okText: okText || 'Delete',
		cancelText: cancelText || 'Cancel',
		...rest,
		okButtonProps: { ...( okButtonProps || {} ), danger: true },
		autoFocusButton: 'cancel',
	});
}

/**
 * The same rule for a `Popconfirm` (a row's ✕ asks in place): spread these
 * onto it. Popconfirm focuses nothing, so there is no Enter to guard — the
 * red OK and the verb are what must match the modal.
 *
 *   <Popconfirm title="Revoke this link?" {...destructivePopconfirmProps('Revoke')} onConfirm={…}>
 */
export function destructivePopconfirmProps(okText = 'Delete') {
	return {
		okText,
		cancelText: 'Cancel',
		okButtonProps: { danger: true },
	};
}

export default confirmDestructive;
